import React from 'react';

function RouteFallback() {
  return (
    <p className="route-fallback" role="status">
      Carregando…
    </p>
  );
}

export default RouteFallback;
